import { videoClips } from "@/mocks/chigua";

export default function ClipsSection() {
  const featured = videoClips[0];
  const rest = videoClips.slice(1, 5);

  return (
    <section id="clips" className="scroll-mt-28 bg-cream">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        {/* 分区头 */}
        <div className="mb-9 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-ember/10 px-3 py-1 text-xs font-bold text-ember">
              <i className="ri-vidicon-line" />
              大图卡片流 · 上疏下密
            </span>
            <h2 className="mt-3 font-display-x text-3xl font-black md:text-4xl">
              视频片段 · 名场面随看随取
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/60 md:text-base">
              高能瞬间都单独切好，按事件、时长与热度标注。取素材不用整段翻，点卡片直接定位关键节点。
            </p>
          </div>
          <a
            href="#clips"
            className="flex items-center justify-center gap-2 whitespace-nowrap self-start rounded-full border border-sand bg-paper px-5 py-2.5 text-sm font-semibold text-ink/80 transition hover:bg-peach sm:self-auto"
          >
            进入片段库
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* 主卡（疏） */}
        <a
          href="#clips"
          className="group grid grid-cols-1 gap-6 overflow-hidden rounded-3xl bg-paper p-3 ring-1 ring-sand/60 lg:grid-cols-[1.5fr_1fr] lg:gap-2 lg:p-4"
        >
          <div className="relative h-[300px] w-full overflow-hidden rounded-2xl bg-sand md:h-[400px]">
            <img
              src={featured.cover}
              alt={featured.title}
              className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
            />
            <span className="absolute left-4 top-4 rounded-full bg-ink/80 px-3 py-1 text-xs font-bold text-cream backdrop-blur">
              <i className="ri-fire-fill mr-1 text-amber" />
              本期置顶
            </span>
            <span className="absolute bottom-4 right-4 rounded-md bg-ink/75 px-2 py-1 font-mono text-xs text-cream">
              {featured.length}
            </span>
          </div>
          <div className="flex flex-col justify-between p-3 lg:p-5">
            <div>
              <span className="inline-flex rounded-md bg-peach px-2.5 py-1 text-xs font-bold text-ember">
                {featured.tag}
              </span>
              <h3 className="mt-4 font-display-x text-2xl font-bold leading-snug md:text-3xl">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink/60">
                完整片段已按事件前后顺序整理，附同帧截图指引与二次传播热度说明，方便快速取用或引用出处。
              </p>
            </div>
            <div className="mt-6 flex items-center justify-between border-t border-sand/60 pt-4">
              <span className="text-xs text-ink/45">
                <i className="ri-fire-line mr-1 text-ember" />
                {featured.heat}
              </span>
              <span className="flex items-center gap-1.5 text-sm font-bold text-ember">
                <i className="ri-play-circle-line text-lg" />
                看片段
              </span>
            </div>
          </div>
        </a>

        {/* 小卡（密） */}
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {rest.map((v) => (
            <a
              key={v.title}
              href="#clips"
              className="group overflow-hidden rounded-2xl bg-paper ring-1 ring-sand/60 transition hover:-translate-y-1"
            >
              <div className="relative h-40 w-full overflow-hidden bg-sand">
                <img
                  src={v.cover}
                  alt={v.title}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-3 right-3 rounded-md bg-ink/70 px-1.5 py-0.5 font-mono text-[11px] text-cream">
                  {v.length}
                </span>
              </div>
              <div className="p-4">
                <span className="rounded-md bg-cream px-2 py-0.5 text-[11px] font-bold text-ember">
                  {v.tag}
                </span>
                <h3 className="mt-2 line-clamp-2 text-sm font-bold leading-snug text-ink">
                  {v.title}
                </h3>
                <p className="mt-2 text-[11px] text-ink/45">
                  <i className="ri-fire-line mr-1 text-ember" />
                  {v.heat}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}